import { useState } from "react";
import { withRouter } from "react-router-dom";
import '../assets/css/partnerProgram.scss';
import Image from "react-bootstrap/Image";
import Title from "./Title";


function ContentExplanation(props) {


    const [title] = useState(props.title);
    const [sectionText] = useState(props.sectionText);
    const [sectionImage] = useState(props.sectionImage);


    return (

        <div>
           {title === "" ? "" : <Title className={"mt-5 w-100"} classNameText="mb-4" title={title}/>}
            <div className="contentBlock">
                <div className="contentBlockFrame">
                    <div className="contentBlockSection">
                        <div className="contentBlockSubCopy">
                            <div className="contentBlockText">{sectionText}</div>
                        </div>      
                    </div>
                    
                    <div className="contentImage ">
                        <Image className="imagePosted" src={sectionImage} />
                    </div>
                </div>

            </div>
        </div>

    )


}

export default withRouter(ContentExplanation);



